import Styles from './EditAccess.module.scss'
import { useShareSheetContext } from '../ShareSheetV2'
import { InviteUsers } from 'components/ShareSheet/InviteUsers'
import { Accesses } from 'components/ShareSheet/Accesses'
import useShareSheetV2 from 'hooks/useShareSheetV2'
import { InviteCollaborators } from 'components/ShareSheet/InviteCollaborators'
import { Modal } from 'almanac-ui/Modal'

export const EditAccess = ({ title }: { title?: string }) => {
  const { file } = useShareSheetContext()
  const { recipients } = useShareSheetV2(file)

  if (recipients.length > 0) {
    return <InviteCollaborators file={file} />
  }

  return (
    <div className={Styles.container}>
      <Modal.Header title={title || 'Edit Access'} />
      <div className={Styles.body}>
        <InviteUsers file={file} />
        <Accesses file={file} />
      </div>
    </div>
  )
}
